/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_AboutInputs */

const th_event_about = /** @type {(inputs: Event_AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ข้อมูล`)
};

const en_event_about = /** @type {(inputs: Event_AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`About`)
};

const ja_event_about = /** @type {(inputs: Event_AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`概要`)
};

const zh_event_about = /** @type {(inputs: Event_AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`简介`)
};

const es_event_about = /** @type {(inputs: Event_AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Información`)
};

const pt_event_about = /** @type {(inputs: Event_AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sobre`)
};

const id_event_about = /** @type {(inputs: Event_AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tentang`)
};

const fr_event_about = /** @type {(inputs: Event_AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`À propos`)
};

const tl_event_about = /** @type {(inputs: Event_AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tungkol`)
};

const vi_event_about = /** @type {(inputs: Event_AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giới thiệu`)
};

const ko_event_about = /** @type {(inputs: Event_AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`소개`)
};

const de_event_about = /** @type {(inputs: Event_AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Über`)
};

const ru_event_about = /** @type {(inputs: Event_AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`О событии`)
};

const tr_event_about = /** @type {(inputs: Event_AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hakkında`)
};

const it_event_about = /** @type {(inputs: Event_AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Informazioni`)
};

const pl_event_about = /** @type {(inputs: Event_AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O wydarzeniu`)
};

const uk_event_about = /** @type {(inputs: Event_AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Про подію`)
};

const hi_event_about = /** @type {(inputs: Event_AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`परिचय`)
};

const ar_event_about = /** @type {(inputs: Event_AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`نبذة`)
};

const ms_event_about = /** @type {(inputs: Event_AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mengenai`)
};

const bn_event_about = /** @type {(inputs: Event_AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`পরিচিতি`)
};

const zh_tw2_event_about = /** @type {(inputs: Event_AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`簡介`)
};

const zh_hk2_event_about = /** @type {(inputs: Event_AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`簡介`)
};

const ur_event_about = /** @type {(inputs: Event_AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تعارف`)
};

const fa_event_about = /** @type {(inputs: Event_AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`دربارهٔ`)
};

const sw_event_about = /** @type {(inputs: Event_AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kuhusu`)
};

const nl_event_about = /** @type {(inputs: Event_AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Over`)
};

/**
* | output |
* | --- |
* | "About" |
*
* @param {Event_AboutInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const event_about = /** @type {((inputs?: Event_AboutInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_AboutInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_event_about(inputs)
	if (locale === "ja") return ja_event_about(inputs)
	if (locale === "zh") return zh_event_about(inputs)
	if (locale === "es") return es_event_about(inputs)
	if (locale === "pt") return pt_event_about(inputs)
	if (locale === "id") return id_event_about(inputs)
	if (locale === "fr") return fr_event_about(inputs)
	if (locale === "tl") return tl_event_about(inputs)
	if (locale === "vi") return vi_event_about(inputs)
	if (locale === "ko") return ko_event_about(inputs)
	if (locale === "de") return de_event_about(inputs)
	if (locale === "ru") return ru_event_about(inputs)
	if (locale === "tr") return tr_event_about(inputs)
	if (locale === "it") return it_event_about(inputs)
	if (locale === "pl") return pl_event_about(inputs)
	if (locale === "uk") return uk_event_about(inputs)
	if (locale === "hi") return hi_event_about(inputs)
	if (locale === "ar") return ar_event_about(inputs)
	if (locale === "ms") return ms_event_about(inputs)
	if (locale === "bn") return bn_event_about(inputs)
	if (locale === "zh-TW") return zh_tw2_event_about(inputs)
	if (locale === "zh-HK") return zh_hk2_event_about(inputs)
	if (locale === "ur") return ur_event_about(inputs)
	if (locale === "fa") return fa_event_about(inputs)
	if (locale === "sw") return sw_event_about(inputs)
	if (locale === "nl") return nl_event_about(inputs)
	return en_event_about(inputs)
});